// TikTok pixel consent wiring. Mirrors `@/integrations/posthog/consent` but for
// the marketing category. The pixel is only injected once marketing consent is
// granted (see `TikTokPixel`); this keeps the already-loaded `ttq` in sync when
// the visitor changes their mind mid-session — revoking consent stops further
// cookies/events without a reload.

import type { ConsentValue } from "@/features/consent/consent-storage";

interface TiktokPixelApi {
  grantConsent?: () => void;
  revokeConsent?: () => void;
  disableCookie?: () => void;
}

function getTtq(): TiktokPixelApi | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }
  return (window as unknown as { ttq?: TiktokPixelApi }).ttq;
}

export function applyTikTokConsent(value: ConsentValue): void {
  const ttq = getTtq();
  if (!ttq) {
    // Pixel not loaded yet (or never, if consent was never granted). Nothing
    // to toggle — the snippet loads in a granted state, so absence == no data.
    return;
  }
  if (value === "granted") {
    ttq.grantConsent?.();
  } else {
    ttq.revokeConsent?.();
    ttq.disableCookie?.();
  }
}
